import {
NarrativeViewWidget,   ShortCheckboxWidget,
  WideCheckboxWidget,
  ShortTextWidget,
  WideTextWidget,
  NumberWidget,
  TextWidget,
  RichTextWidget,
  DateTimeWidget,
  DateWidget,
  TimeWidget,
  TextareaWidget,
  SelectWidget,
  TagSelectWidget,
  HiddenWidget,
  NarrativeWidget,
} from ".";

// Export all widgets as a collection for easy registration with RJSF
export const customWidgets = {
  // Checkbox widgets
  ShortCheckboxWidget,
  WideCheckboxWidget,
  CheckboxWidget: ShortCheckboxWidget, // Default checkbox

  // Text widgets
  ShortTextWidget,
  WideTextWidget,
  TextWidget,
  TextareaWidget,
  RichTextWidget,
  NarrativeViewWidget,

  // Number widget
  NumberWidget,

  // Date/Time widgets
  DateTimeWidget,
  DateWidget,
  TimeWidget,

  // Select widget
  SelectWidget,
  TagSelectWidget,

  // Hidden widget
  HiddenWidget,

  // Narrative widget with AI assistance
  NarrativeWidget,
};
